import { observer } from 'mobx-react';
import { FormattedMessage, useIntl } from 'react-intl';
import React from 'react';
import { DefaultPageViewModel } from '../default-page.viewmodel';
import { CALENDAR_BUTTON_ENABLED, WELCOME_KNOVIO_EMBED_ID, WELCOME_KNOVIO_ENABLED } from '../../../../../../../../modules/passport-pages/config';
import { FormField } from '../../../../../../../global/form/form-field/form-field';
import { OEToggle } from '../../../../../../../global/oe-toggle/oe-toggle';
import Text from '../../../../../../../global/text/text';
import { KnovioLabel } from '../../../../../../../../api/connections.dao';

type Props = {
    pageVm: DefaultPageViewModel;
};


export const WelcomePageFields = observer(({ pageVm }: Props): JSX.Element => {
    const { formatMessage } = useIntl();

    const embedId = pageVm.getFieldByKey(WELCOME_KNOVIO_EMBED_ID);
    const embedIdLabel = formatMessage(pageVm.getFieldConfigByKey(WELCOME_KNOVIO_EMBED_ID).labelDescriptor, { prefix: pageVm.pageName });

    const { value: welcomeKnovioEnabled } = pageVm.getFieldByKey(WELCOME_KNOVIO_ENABLED);
    const toggleWelcomeKnovio = () => pageVm.setFieldValueByKey(WELCOME_KNOVIO_ENABLED, !welcomeKnovioEnabled);

    const { value: calendarButtonEnabled } = pageVm.getFieldByKey(CALENDAR_BUTTON_ENABLED);
    const toggleWelcomeCalendarEnabled = () => pageVm.setFieldValueByKey(CALENDAR_BUTTON_ENABLED, !calendarButtonEnabled);

    return (
        <>
            <FormField>
                <div className='flex'>
                    <OEToggle
                        isSelected={welcomeKnovioEnabled as boolean}
                        onClick={toggleWelcomeKnovio}
                    />
                    {
                        welcomeKnovioEnabled
                        ? <Text message={`Welcome ${KnovioLabel.OEStream} is enabled`} id='oe.defaultPage.welcomeKnovioEnabled' description='Label text' />
                        : <Text message={`Welcome ${KnovioLabel.OEStream} is disabled`} id='oe.defaultPage.welcomeKnovioDisabled' description='Label text' />
                    }
                </div>
            </FormField>
            <FormField label={embedIdLabel}>
                <div className='flex'>
                    <input
                        className='oe-form-field__control'
                        onBlur={pageVm.setValueTouched.bind(pageVm, WELCOME_KNOVIO_EMBED_ID)}
                        value={embedId.value as string || ''}
                        type='text'
                        onChange={e => pageVm.setFieldValueByKey(WELCOME_KNOVIO_EMBED_ID, e.target.value)}
                    />
                </div>
                <span className='oe-form-field__error'>
                    {
                        !embedId.valid && embedId.touched &&
                        <FormattedMessage values={{ fieldName: embedIdLabel }} {...embedId.validationMessage} />
                    }
                    {
                        welcomeKnovioEnabled && embedId.touched && !embedId.value &&
                        <FormattedMessage
                            id='oe.validation.required.message'
                            values={{ fieldName: embedIdLabel }}
                            defaultMessage='{fieldName} is required.'
                        />
                    }
                </span>
            </FormField>
            <FormField>
                <div className='website-custom__checkbox-label m-top-15px m-bottom-0px'>
                    <OEToggle
                        isSelected={calendarButtonEnabled as boolean}
                        onClick={toggleWelcomeCalendarEnabled}
                    />
                    <Text
                        message={'Show "Add to Calendar" button'}
                        id={'oe.website.showAddToCalendarButton'}
                        description={'Label text'}
                    />
                </div>
            </FormField>
        </>
    );
});
